export default __webpack_public_path__ + "0809154440d56e4db241bca00d4e6b66.webp";